import { useState, useEffect } from 'react'
import { useToast } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { Research, ResearchTag } from '../../../../types/Research'
import {
  fetchResearchById,
  fetchResearchTags,
} from '../../../../utils/researchUtils'

export const useResearchDetails = (id: string | undefined) => {
  const [research, setResearch] = useState<Research | null>(null)
  const [tags, setTags] = useState<ResearchTag[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const navigate = useNavigate()
  const toast = useToast()

  useEffect(() => {
    const loadData = async () => {
      if (!id) {
        navigate('/research')
        return
      }

      try {
        setLoading(true)
        setError(null)
        const [researchData, tagsData] = await Promise.all([
          fetchResearchById(id),
          fetchResearchTags(),
        ])

        if (!researchData) {
          setError('Research not found')
          toast({
            title: 'Research not found',
            description: 'The requested research article could not be found',
            status: 'error',
            duration: 5000,
            isClosable: true,
          })
          navigate('/research')
          return
        }

        setResearch(researchData)
        setTags(tagsData)
      } catch (error) {
        setError('Failed to load research')
        toast({
          title: 'Error loading research',
          description: 'Could not load the research article',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
        navigate('/research')
      } finally {
        setLoading(false)
      }
    }

    loadData()
  }, [id, navigate, toast])

  return {
    research,
    tags,
    loading,
    error,
  }
}
